import Button from './buttons/Button'
import Icon from './Icon'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class DropdownMenuTrigger extends PureComponent {
  static propTypes = {
    text: PropTypes.string.isRequired
  }

  render() {
    return (
      <Button size="small" className="dropdown-toggle" data-toggle="dropdown">
        <span>{this.props.text + ' '}</span>
        <Icon name="chevron-down" />
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/DropdownMenuTrigger.js